import {
  INICIA_ESCOLA,
  SALVA_ESCOLA,
  REMOVE_ESCOLA,
  NOVO_ESCOLA,
  BUSCA_ESCOLA_EDICAO,
  INICIO_ESCOLA_SUCESSO,
  SALVA_ESCOLA_SUCESSO,
  REMOVE_ESCOLA_SUCESSO,
  BUSCA_ESCOLA_EDICAO_SUCESSO,
  ATUALIZA_ESCOLA,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  LISTA_ESCOLA,
  LISTA_ESCOLA_SUCESSO,
  LIMPAR_ESCOLA,
  ADICIONA_ESCOLA_CURSO,
  REMOVE_ESCOLA_CURSO,
  ALTERA_ESCOLA_CURSO,
  LISTA_CURSOS_ESCOLA_SUCESSO,
  LISTA_ANOS_LETIVOS_POR_ESCOLA,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_SUCESSO,
  APLICA_FILTRO_ESCOLA
} from 'constants/ActionTypes';

/*#############################################################################################*/
/* ------------------------------ Actions Fundamentais CRUD -----------------------------------*/

export const iniciaEscola = () => {
  return {
    type: INICIA_ESCOLA
  };
};

export const salvaEscola = (escola) => {
  return {
    type: SALVA_ESCOLA,
    payload: escola
  };
};

// Opcional: ação explícita para atualizar escola (se quisermos separar do SALVA)
export const atualizaEscola = (escola) => {
  return {
    type: ATUALIZA_ESCOLA,
    payload: escola
  };
};

export const removeEscola = (id) => {
  return {
    type: REMOVE_ESCOLA,
    payload: id
  };
};

export const listaEscola = (nome) => {
  if (nome == undefined) {
    nome = "";
  }

  return {
    type: LISTA_ESCOLA,
    payload: { nome }
  };
};


/*#############################################################################################*/
/* ---------------------------- Actions do Fluxo de Navegação ---------------------------------*/

export const novoEscola = () => {
  return {
    type: NOVO_ESCOLA
  };
};

export const buscaEscolaEdicao = (id) => {
  return {
    type: BUSCA_ESCOLA_EDICAO,
    payload: id
  };
};

/*#############################################################################################*/
/* --------------------------- Actions de respostas actions anteriores ------------------------*/  

export const inicioEscolaSucesso = (escolas, locaisControlados = []) => {
  return {
    type: INICIO_ESCOLA_SUCESSO,
    payload: { escolas, locaisControlados }
  }
};

export const salvaEscolaSucesso = (mensagem) => {
  return {
    type: SALVA_ESCOLA_SUCESSO,
    payload: mensagem
  }
};

export const onChangeFilterEscola = (e) => {
  return {
      type: APLICA_FILTRO_ESCOLA,
      payload: e.target.value
  }
};

export const removeEscolaSucesso = (mensagem) => {
  return {
    type: REMOVE_ESCOLA_SUCESSO,
    payload: mensagem
  }
};  

export const buscaEscolaEdicaoSucesso = (escola) => {
  return {
    type: BUSCA_ESCOLA_EDICAO_SUCESSO,
    payload: escola
  };
};

export const listaEscolaSucesso = (escola) => {
  return {
    type: LISTA_ESCOLA_SUCESSO,
    payload: { escola }
  };
};

export const limparFiltroEscola = () => {
  return {
    type: LIMPAR_ESCOLA,
  };
};

/*#############################################################################################*/
/* ---------------------------------- Outras Actions Auxiliares -------------------------------*/ 

export const exibirMensagemErro = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const adicionaEscolaCurso = (item) => {
  return {
    type: ADICIONA_ESCOLA_CURSO,
    payload: item
  };
};

export const removeEscolaCurso = (cursoId) => {
  return {
    type: REMOVE_ESCOLA_CURSO,
    payload: { cursoId }
  };
};

export const alteraEscolaCurso = (cursoId, changes) => {
  return {
    type: ALTERA_ESCOLA_CURSO,
    payload: { cursoId, changes }
  };
};

export const listaCursosEscolaSucesso = (cursos) => {
  return {
    type: LISTA_CURSOS_ESCOLA_SUCESSO,
    payload: { cursos }
  };
};

export const listaAnosLetivosPorEscola = (escolaId) => {
  return {
    type: LISTA_ANOS_LETIVOS_POR_ESCOLA,
    payload: { escolaId }
  };
};

export const listaAnosLetivosPorEscolaSucesso = (anos) => {
  return {
    type: LISTA_ANOS_LETIVOS_POR_ESCOLA_SUCESSO,
    payload: { anos }
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};
